import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  //创建入驻申请
  createSettledCompany: {
    url: "/adminc/v1/organization_manage/o_company_apply/create_settled_company",
    method: 'post'
  },
  //进度查询
  getCheckList: {
    url: '/adminc/v1/organization_manage/o_company_apply/get_check_list',
    method: 'get'
  },
  //单位详细信息
  getCompDetail: {
    url: '/adminc/v1/organization_manage/o_company_apply/get_comp_apply_detail',
    method: 'get'
  },
  //修改保存
  updateSettledCompany: {
    url: '/adminc/v1/organization_manage/o_company_apply/update_settled_company',
    method: 'put'
  }, //上传图片
  uploadFile: {
    url: '/adminc/v1/upload/upload_file_remote_open',
    method: 'post'
  },
  //获取省接口
  getProvince: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_open_list',
    method: 'get',
  },
  //获取市接口
  getCity: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_open_list',
    method: 'get',
  },
  //获取区接口
  getArea: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_open_list',
    method: 'get',
  },
  //获取证件类型
  getCard: {
    url: '/adminc/v1/config_manage/b_code/get_code_open_list',
    method: 'get',
  },
  //修改-保存
  updateCompany: {
    url: '/adminc/v1/organization_manage/o_company_apply/update_settled_company',
    method: 'put'
  }

}
export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/Login/OtherChannelsApplication.js